"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.nav.dashboard': '仪表板',
    'socialMediaPlan.nav.channels': '渠道',
    'socialMediaPlan.nav.analytics': '分析',
};
